import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=28b49dc2&scoped=true&"
import script from "./OrderDetails.vue?vue&type=script&lang=ts&"
export * from "./OrderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=28b49dc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b49dc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
